import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
export default new Router({
  routes: [
    {
      path: '/',
      component: () => import('../views/index/index'),
      redirect: {
        name: 'index'
      }
    },
    {
      path: '/index',
      component: () => import('../views/index/index'),
      name: 'index',
      meta: {
        keep_alive: false
      }
    },
    {
      path: '/roomPrice',
      component: () => import('../views/roomPrice/index'),
      name: 'roomPrice',
      meta: {
        keep_alive: false
      }
    },
    {
      path: '/historyPrice',
      component: () => import('../views/historyPrice/index'),
      name: 'historyPrice',
      meta: {
        keep_alive: false
      }
    },
    {
      path: '/makeCount',
      component: () => import('../views/makeCount/index'),
      name: 'makeCount',
      meta: {
        keep_alive: false
      }
    },
    {
      path: '/communitySearch',
      component: () => import('../views/communitySearch/index'),
      name: 'communitySearch',
      meta: {
        keep_alive: false
      }
    },
    {
      path: '/selectCity',
      component: () => import('../views/selectCity/index'),
      name: 'selectCity',
      meta: {
        keep_alive: false
      }
    },
    /** 实勘填报 **/
    {
      path: '/solidFill',
      component: () => import('../views/solidFill/index'),
      name: 'solidFill',
      meta: {
        keep_alive: false
      }
    },
    {
      path: '/settingRoom',
      component: () => import('../views/settingRoom/index'),
      name: 'settingRoom',
      meta: {
        keep_alive: false
      }
    },
    {
      path: '/collectPrice',
      component: () => import('../views/collectPrice/index'),
      name: 'collectPrice',
      meta: {
        keep_alive: false
      }
    },
    {
      path: '/kitchen',
      component: () => import('../views/kitchen/index'),
      name: 'kitchen',
      meta: {
        keep_alive: false
      }
    },
    {
      path: '/bedroom',
      component: () => import('../views/bedroom/index'),
      name: 'bedroom',
      meta: {
        keep_alive: false
      }
    },
    {
      path: '/roomType',
      component: () => import('../views/roomType/index'),
      name: 'roomType',
      meta: {
        keep_alive: false
      }
    },
    // 工程改造
    {
      path: '/engineered',
      component: () => import('../views/engineered/index'),
      name: 'engineered',
      meta: {
        keep_alive: false
      }
    },
    // 优化间
    {
      path: '/optimizeRoom',
      component: () => import('../views/optimizeRoom/index'),
      name: 'optimizeRoom',
      meta: {
        keep_alive: false
      }
    },
    // 优化间
    {
      path: '/aloneRoom',
      component: () => import('../views/aloneRoom/index'),
      name: 'aloneRoom',
      meta: {
        keep_alive: false
      }
    },
    // 测量工程
    {
      path: '/measurement',
      component: () => import('../views/measurement/index'),
      name: 'measurement',
      meta: {
        keep_alive: false
      }
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({ x: 0, y: 0 })
      }, 0)
    })
  }
})


// WEBPACK FOOTER //
// ./src/router/index.js